import React, { useRef } from 'react';
import styles from './style.module.scss';
import { Button, MenuItem, Grid } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { OverlayTrigger, Popover } from "react-bootstrap";
import { CatalogueRequestStatus } from './constant';
import { useOutsideClick } from '../../components/OutsideClick/handleOutsideClick';

const FilterComponent = (props) => {

    const overlayStatus = useRef(null);

    //Popover component
    const popover = (list, type) => (
        <Popover id="popover-basic" >
            <Popover.Content id={styles.popContent}>
                <div className={styles.popoverBody}>
                    {type === 'requestStatus' &&
                        list.map((name, index) => (
                            <div key={index}>
                                <MenuItem name={name.label} value={name.value} onClick={(e) => props.filterChange(name.value, type)}>{name.label}</MenuItem>
                            </div>
                        ))}
                </div>
            </Popover.Content>
        </Popover>
    );

    //function to handle popover ref
    const getRef = () => {
        if (props.showFilters.requestStatus)
            return overlayStatus
    }


    //function to handle outside click
    useOutsideClick(getRef(), () => {
        let obj;
        if (props.showFilters.requestStatus)
            obj = 'requestStatus';
        props.cancelFilters(obj)
    });

    return <div className={styles.filterComp}>
        <Grid container alignItems="center" spacing={0}>
            <Grid container md={10} alignItems="center" spacing={3}>
                <span className="pl-3">Filters:</span>
                <Grid item auto="true" >
                    <div ref={overlayStatus}>
                        <OverlayTrigger container={overlayStatus.current} trigger="click" placement="right" show={props.showFilters.requestStatus} overlay={popover(CatalogueRequestStatus, 'requestStatus')} >
                            <Button variant="contained" className={styles.dateBtn} disableElevation onClick={() => props.showFiltersFnc('requestStatus')}>
                                Inventory Request Status
                                <span className="pl-2 d-flex align-items-end">  <ExpandMoreIcon fontSize="small" /></span>
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Grid>
            </Grid>
            <Grid container md={2} alignItems="center" justifycontent="flex-end" spacing={3}>
                <Grid item md={12}>
                    <div className="d-flex justify-content-end align-items-center">
                        <Button variant="contained" className={styles.addInv} color="primary" onClick={() => props.setShowCatalogueModal()} >
                            Add&nbsp;Inventory
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    </div>
}

const RequestFiltersComponent = React.memo(FilterComponent);
export default RequestFiltersComponent;

